"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _widgets = require("../../../../components/widgets");

var _moment = _interopRequireDefault(require("moment"));

var _components = require("../../../../components");

var _Api = _interopRequireDefault(require("../../../../logic/api/Api"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var BulkLoadInfo = /*#__PURE__*/function (_React$Component) {
  _inherits(BulkLoadInfo, _React$Component);

  function BulkLoadInfo() {
    _classCallCheck(this, BulkLoadInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(BulkLoadInfo).apply(this, arguments));
  }

  _createClass(BulkLoadInfo, [{
    key: "_download",
    value: function _download(bulkLoad) {
      _Api["default"].guardedDownload(bulkLoad.file);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var bulkLoad = this.props.bulkLoad;
      var details = [{
        label: 'Name',
        value: bulkLoad.name
      }, {
        label: 'Created',
        value: (0, _moment["default"])(bulkLoad.created).format('DD/MM/YYYY HH:mm:ss')
      }, {
        label: 'Record count',
        value: bulkLoad.recordCount
      }, {
        label: 'Successful loads',
        value: bulkLoad.successCount
      }, {
        label: 'Failed loads',
        value: bulkLoad.failureCount
      }, {
        label: 'Status',
        value: _react["default"].createElement(_components.AppBadge, {
          text: bulkLoad.status
        })
      }, {
        label: 'Download uploaded file',
        value: _react["default"].createElement("a", {
          href: "javascript:void(0)",
          onClick: function onClick() {
            return _this._download(bulkLoad);
          }
        }, _react["default"].createElement(_components.AppBadge, {
          text: 'download'
        }))
      }];
      return _react["default"].createElement(_widgets.AppInfoList, {
        items: details
      });
    }
  }]);

  return BulkLoadInfo;
}(_react["default"].Component);

exports["default"] = BulkLoadInfo;